/**
 * @description
 *	Available environments.
 */
enum Environment {
	Development = "Development",
	Local = "Local",
	Production = "Production",
	Staging = "Staging",
	Testing = "Testing"
}

export default Environment
